import { variantSummary } from './variant-quantities.mjs';
const rp = value => 'Rp ' + Number(value || 0).toLocaleString('id-ID');

// Narrow columns fit typical WhatsApp chat bubbles; monospace preserves spaces.
export const RECEIPT_COLUMNS = 32;
const clean = value => String(value ?? '').normalize('NFC').replace(/`/g, "'").replace(/\r\n?/g, '\n').replace(/[\u0000-\u0009\u000b-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069]/g, ' ');
const length = value => Array.from(value).length;

function wrap(value, width = RECEIPT_COLUMNS) {
  return clean(value).split('\n').flatMap(paragraph => {
    const output = [];
    let line = '';
    for (const word of paragraph.trim().split(/\s+/)) {
      if (line && length(line) + 1 + length(word) > width) { output.push(line); line = ''; }
      let rest = Array.from(word);
      while (rest.length > width) { output.push(rest.slice(0, width).join('')); rest = rest.slice(width); }
      const tail = rest.join('');
      if (tail) line += (line ? ' ' : '') + tail;
    }
    if (line || !output.length) output.push(line);
    return output;
  });
}

export function draftReceiptText(tx, storeName) {
  const lines = [];
  const add = value => lines.push(...wrap(value));
  const center = value => wrap(value).forEach(line => lines.push(' '.repeat(Math.floor((RECEIPT_COLUMNS - length(line)) / 2)) + line));
  const rule = () => lines.push('-'.repeat(RECEIPT_COLUMNS));
  const row = (label, amount) => {
    const left = clean(label).replace(/\s+/g, ' ').trim();
    const right = clean(amount).replace(/\s+/g, ' ').trim();
    if (length(left) + length(right) + 1 <= RECEIPT_COLUMNS) {
      lines.push(left + ' '.repeat(RECEIPT_COLUMNS - length(left) - length(right)) + right);
    } else {
      add(left);
      wrap(right).forEach(line => lines.push(' '.repeat(RECEIPT_COLUMNS - length(line)) + line));
    }
  };
  center(storeName || 'POS MASIVI');
  rule();
  center('RESI PESANAN');
  center('BELUM DIBAYAR');
  if (tx.created_at) {
    const date = new Date(tx.created_at);
    if (!Number.isNaN(date.getTime())) add('Tgl: ' + date.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }));
  }
  if (tx.cashier) add('Kasir: ' + tx.cashier);
  if (tx.customer_name) add('Pelanggan: ' + tx.customer_name);
  rule();
  for (const item of tx.items) {
    add(item.name);
    add(`${item.unit || item.price_level || 'Pcs'} x ${item.qty}`);
    row(`${item.qty} x ${rp(item.price)}`, rp(item.qty * item.price));
    if (variantSummary(item)) add(variantSummary(item));
    if (item.discount > 0) row('Diskon item', '-' + rp(item.discount));
    if (item.note) add('Catatan: ' + item.note);
    lines.push('');
  }
  rule();
  row('Jumlah produk', String(tx.items.length));
  row('Subtotal', rp(tx.subtotal));
  if (tx.discount > 0) row('Diskon', '-' + rp(tx.discount));
  for (const debt of tx.previous_debts || []) row(`Piutang sebelumnya (${debt.invoice_no.slice(-4)})`, rp(debt.amount));
  row('TOTAL', rp(tx.total + (tx.settlement_total || 0)));
  if (tx.note) { rule(); add('Catatan resi:'); add(tx.note); }
  rule();
  center('TERIMA KASIH');
  return lines.join('\n');
}

export function whatsappMonospace(text) {
  return '```\n' + clean(text) + '\n```';
}

export function whatsappReceiptUrl(phone, message) {
  const raw = String(phone || '').trim();
  if (!/^[+\d\s()-]+$/.test(raw)) return null;
  let number = raw.replace(/\D/g, '');
  if (number.startsWith('0')) number = '62' + number.slice(1);
  else if (number.startsWith('8')) number = '62' + number;
  if (!/^[1-9]\d{7,14}$/.test(number)) return null;
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}
